import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";
import { ValueGetterParams } from "ag-grid-community";
import { DIMENSION_IDS_DELIMITER } from "epics/collections";

export const DOOR_PERCENTAGE_PLAN = ({ factoryOptions, getterParams }) => {
    const retailFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.TOTAL_RETAIL } };
    const retailPlanRows = SIMPLE_SUM({ factoryOptions: retailFactoryOptions, getterParams });
    const { filteredDeliveriesForAssortmentSet, filteredDoorsForAssortmentSet } = factoryOptions;

    const {
        data: { reviewPlan },
    }: ValueGetterParams = getterParams;

    let totalRetailForPlanRow = 0;
    if (reviewPlan) {
        Object.keys(reviewPlan).forEach((key) => {
            const reviewPlanItem = reviewPlan[key].struct_value;
            const tokens = key.split(DIMENSION_IDS_DELIMITER);
            let doorKey;
            let deliveryKey;

            if (tokens.length === 3) {
                doorKey = tokens[0];
                deliveryKey = tokens[2];
            } else if (tokens.length > 0) {
                doorKey = tokens[0];
            }

            // Find metric for this item
            if (reviewPlanItem.metrics) {
                for (const metric of reviewPlanItem.metrics) {
                    const metricValue = metric.value?.number_value ?? 0;
                    if (
                        metric.kind === MetricsKind.TOTAL_RETAIL &&
                        filteredDeliveriesForAssortmentSet.has(deliveryKey) &&
                        filteredDoorsForAssortmentSet.has(doorKey)
                    ) {
                        totalRetailForPlanRow += metricValue;
                        break;
                    }
                }
            }
        });
    }

    if (totalRetailForPlanRow > 0 && retailPlanRows > 0) {
        return (retailPlanRows / totalRetailForPlanRow) * 100;
    }

    return 0;
};
